import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class familiaSunatService {

    /******* QUERIES ******/

    async listarPorIdSegmentoSunat(idSegmentoSunat) {
        const response = await axios
            .get(`${ERP}administracion/familia-sunat/por-segmento-sunat/${idSegmentoSunat}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
}

export default new familiaSunatService();